import Skeleton from "../../../../components/Skeleton/Skeleton";

const PageSkeleton = () => (
  <div className="flex flex-col">
    {/* Table header */}
    <div className="flex justify-between px-4 py-3 border-b border-[#EBEBEB]">
      <Skeleton width="140px" height="16px" />
      <Skeleton width="80px" height="16px" />
    </div>

    {/* Table rows */}
    {Array.from({ length: 4 }).map((_, i) => (
      <div key={i} className="flex justify-between items-center px-4 py-4 border-b border-[#EBEBEB]">
        <div className="flex flex-col gap-1.5">
          <Skeleton width="160px" height="16px" />
          <Skeleton width="100px" height="12px" />
        </div>
        <div className="flex items-center gap-2.5">
          <Skeleton width="80px" height="16px" />
          <Skeleton width="24px" height="24px" />
        </div>
      </div>
    ))}
  </div>
);

export default PageSkeleton;
